export default {
  data() {
    return {
      PERMISIONS: {
        list: false,
        edit: false,
        create: false,
        delete: false,
      }
    }
  },
  created() {
    const baseRule = 'registru_praguri'

    this.initPermision(`${baseRule}.get`,'list')
    this.initPermision(`${baseRule}.patch`,'edit')
    this.initPermision(`${baseRule}.post`,'create')
    this.initPermision(`${baseRule}.delete`,'delete')
  }
}